/**
 * Returns true if the given URL points to a video file,
 * detected by common video file extensions.
 */
export const isVideoUrl = (url: string): boolean =>
  /\.(mp4|webm|ogg|mov|m4v)(\?.*)?$/i.test(url);
